import React, { useEffect, useRef, useState } from "react";

export const Loader: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen scrollbar-hidden">
      <img
        src="/images/logo.gif"
        // src="/icons/tazz/tazz-logo.gif"
        alt="logo"
        className="my-4"
        style={{ width: "140px", height: "140px" }}
      />
    </div>
  );
};

export const BoardLoader: React.FC = () => {
  return (
    <div className="flex flex-col justify-around w-full">
      <img
        src="/images/logo.gif"
        // src="/icons/tazz/tazz-logo.gif"
        alt="logo"
        className="w-[24px] m-auto"
      />
    </div>
  );
};

export const ButtonLoader: React.FC = () => {
  return (
    <div className="flex flex-col justify-around w-full">
      <img
        src="/images/logo.gif"
        //src="/icons/tazz/tazz-logo.gif"
        alt="logo"
        className="w-[24px] m-auto"
      />
    </div>
  );
};

export const DeepseekLoader: React.FC = () => {
  return (
    <div className="flex flex-col justify-around w-full">
      <img
        src="/images/logo.gif"
        //src="/icons/tazz/tazz-logo.gif"
        alt="logo"
        className="w-[24px]"
      />
    </div>
  );
};

export const ChatAnimLoader: React.FC = () => {
  return (
    <div>
      <div className="flex flex-col gap-3 items-start w-[100%] max-w-[800px] m-auto px-0 md:pr-4">
        <div className="bg-white">
          <img
            src="/images/logo.gif"
            //src="/icons/tazz/tazz-logo.gif"
            alt="logo"
            className="my-4 w-6 h-6"
          />
        </div>
        <div className="space-y-3 w-full">
          <div className="flex space-x-2">
            <div className="h-2 bg-gray-200 rounded animate-pulse w-3/4"></div>
            <div className="h-2 bg-gray-200 rounded animate-pulse w-1/4"></div>
          </div>
          <div className="flex space-x-2">
            <div className="h-2 bg-gray-200 rounded animate-pulse w-2/3"></div>
            <div className="h-2 bg-gray-200 rounded animate-pulse w-1/3"></div>
          </div>
          <div className="flex space-x-2">
            <div className="h-2 bg-gray-200 rounded animate-pulse w-1/2"></div>
            <div className="h-2 bg-gray-200 rounded animate-pulse w-1/2"></div>
          </div>
        </div>
        {/* <div className="animated-background w-[100%]">
          <div className="background-masker btn-divide-left"></div>
        </div> */}
        {/* <div className="animated-background w-[70%]">
          <div className="background-masker btn-divide-left"></div>
        </div> */}
        {/* <div className="animated-background w-[40%]">
          <div className="background-masker btn-divide-left"></div>
        </div> */}
      </div>
    </div>
  );
};

export const SuggestionLoader: React.FC = () => {
  return (
    <div className="pl-0">
      <div className="w-full justify-end gap-2 mt-0 md:mt-2">
        <div className="flex flex-col">
          <div className="w-[24px]"></div>
          {/* <div className="space-y-3 w-full"> */}
          <div className="flex space-x-2 py-3 ">
            <div className="h-4 rounded-full bg-gray-200 animate-pulse w-2/3"></div>
            {/* <div className="h-4 bg-gray-200 rounded animate-pulse w-1/4"></div> */}
          </div>
          <div className="flex space-x-2 py-3 border-t border-border_default">
            <div className="h-4 rounded-full bg-gray-200 animate-pulse w-1/3"></div>
            {/* <div className="h-4 bg-gray-200 rounded animate-pulse w-1/3"></div> */}
          </div>
          <div className="flex space-x-2 py-3 border-t border-border_default">
            <div className="h-4 rounded-full bg-gray-200 animate-pulse w-1/2"></div>
            {/* <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div> */}
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export const SidebarLinkLoader: React.FC<{ isExpanded: boolean }> = ({
  isExpanded,
}) => (
  <div className="flex items-center space-x-3 animate-pulse px-2 py-3">
    <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
    {isExpanded && <div className="h-4 bg-gray-200 rounded w-32"></div>}
  </div>
);

export const ProfileSkeleton: React.FC<{ isExpanded: boolean }> = ({
  isExpanded,
}) => (
  <div
    className={`flex items-center w-full ${
      isExpanded ? "justify-between" : "justify-center ml-[6px]"
    }`}
  >
    <div className="flex gap-3 items-center w-[70%] animate-pulse">
      <div className="h-6 w-6 bg-gray-200 rounded-full"></div>
      {isExpanded && <div className="h-5 bg-gray-200 rounded w-32"></div>}
    </div>
    <div className="flex gap-3 items-center animate-pulse">
      {isExpanded && <div className="h-6 w-6 bg-gray-200 rounded-full"></div>}
      {isExpanded && <div className="h-6 w-6 bg-gray-200 rounded-full"></div>}
    </div>
  </div>
);

export function AdaptiveLoadingCircle({ progress = 0 }) {
  const [displayedProgress, setDisplayedProgress] = useState(progress);
  const prevProgressRef = useRef(progress);
  const spinAnimationRef = useRef<number | null>(null);
  const [spinRotation, setSpinRotation] = useState(0);

  // Constants for the circle
  const radius = 40;
  const circumference = 2 * Math.PI * radius;

  // Handle spinning animation when progress is zero
  useEffect(() => {
    if (progress === 0) {
      let startTime: any;

      const animateSpin = (timestamp: any) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;

        // Complete rotation every 1.5 seconds
        const rotation = ((elapsed / 1500) * 360) % 360;
        setSpinRotation(rotation);

        spinAnimationRef.current = requestAnimationFrame(animateSpin);
      };

      spinAnimationRef.current = requestAnimationFrame(animateSpin);

      return () => {
        if (spinAnimationRef.current) {
          cancelAnimationFrame(spinAnimationRef.current);
        }
      };
    } else if (spinAnimationRef.current) {
      cancelAnimationFrame(spinAnimationRef.current);
    }
  }, [progress]);

  // Smooth transition effect for progress changes
  useEffect(() => {
    // Don't animate on first render
    if (prevProgressRef.current === progress) {
      setDisplayedProgress(progress);
      return;
    }

    // Start from the previous value
    let startProgress = prevProgressRef.current;
    const endProgress = progress;
    const difference = endProgress - startProgress;

    // No need to animate if the difference is tiny
    if (Math.abs(difference) < 0.5) {
      setDisplayedProgress(endProgress);
      prevProgressRef.current = endProgress;
      return;
    }

    // For large differences, animate smoothly
    const startTime = performance.now();
    const duration = 800; // Animation duration in ms

    const animateProgress = (timestamp: any) => {
      const elapsed = timestamp - startTime;
      if (elapsed >= duration) {
        setDisplayedProgress(endProgress);
        prevProgressRef.current = endProgress;
        return;
      }

      // Easing function (ease-out-cubic)
      const t = elapsed / duration;
      const easedT = 1 - Math.pow(1 - t, 3);

      const currentProgress = startProgress + difference * easedT;
      setDisplayedProgress(currentProgress);

      requestAnimationFrame(animateProgress);
    };

    requestAnimationFrame(animateProgress);
    prevProgressRef.current = progress;
  }, [progress]);

  // Calculate the strokeDashoffset based on progress
  const strokeDashoffset =
    circumference - (displayedProgress / 100) * circumference;

  return (
    <div className="relative w-6 h-6">
      <svg className="w-full h-full" viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          r={radius}
          stroke="#e0e0e0"
          strokeWidth="8"
          fill="none"
        />
        {progress === 0 ? (
          // Spinning arc when progress is zero
          <circle
            cx="50"
            cy="50"
            r={radius}
            stroke="#B32C90"
            strokeWidth="8"
            strokeDasharray={`${circumference * 0.25} ${circumference * 0.75}`}
            fill="none"
            transform={`rotate(${spinRotation} 50 50)`}
          />
        ) : (
          // Progress arc when uploading
          <circle
            cx="50"
            cy="50"
            r={radius}
            stroke="#B32C90"
            strokeWidth="8"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            fill="none"
            transform="rotate(-90 50 50)"
          />
        )}
      </svg>
    </div>
  );
}

export const ChatLoadingIndicator = () => {
  const [text, setText] = useState("");
  const baseText = "Generating response, please wait";
  const [dots, setDots] = useState("");
  const [typingComplete, setTypingComplete] = useState(false);

  // Typewriter effect for the text
  useEffect(() => {
    if (text.length < baseText.length) {
      const timer = setTimeout(() => {
        setText(baseText.substring(0, text.length + 1));
      }, 35); // Control typing speed
      return () => clearTimeout(timer);
    } else {
      setTypingComplete(true);
    }
  }, [text]);

  // Animated dots effect after typing is complete
  useEffect(() => {
    if (typingComplete) {
      const dotsInterval = setInterval(() => {
        setDots((prev) => {
          if (prev === "") return ".";
          if (prev === ".") return "..";
          if (prev === "..") return "...";
          return "";
        });
      }, 500); // Control dot animation speed
      return () => clearInterval(dotsInterval);
    }
  }, [typingComplete]);

  return (
    <div className="flex flex-col items-start">
      <div className="w-full">
        <div className="flex items-center">
          <div className="text-primary_1 font-light">
            {text}
            {dots}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatLoadingIndicator;
